// The client shell and the consultant read-through fetch /organizations/addons
// once per mount to decide which modules the navigation shows. My Services
// toggles add-ons in place, so it announces the change here and the shells
// refetch — otherwise a newly enabled module only appears after a full reload.

type Listener = () => void;
const listeners = new Set<Listener>();

/** Fire after an add-on or hardening subscription has been changed on the server. */
export function notifyAddonsChanged(): void {
  for (const listener of Array.from(listeners)) listener();
}

/** Subscribe to add-on changes; returns the unsubscribe function for an effect cleanup. */
export function onAddonsChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
